import React from 'react';
import cs from 'classnames';
import css from './index.css';

export default () => {
  return (
    <div className={cs(css.addEmptyWrapper)}>
      <div className={cs(css.emptyWrapper)}>
        <img src="/assets/alert-empty-state.svg" alt=""/>
        <h4>There's no alerts for this equipment type.</h4>
        <p>Add load alerts to post your trucks on the Truckloads loadboard.</p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/ListEmpty/index.js